import { CharacteristicModel } from '../GlobalRegistry/CharacteristicsModel';

export class CustomerModel {
  CustomerId: number
  OrgId: number
  Name: string
  LandlineNo: number
  MobileNo: number
  Fax: string
  Email: string
  Website: string
  CreatedBy: number
  CreatedDate: string
  UpdatedBy: number
  UpdatedDate: string
  StatusTypeId: number
  lstCustomerChars: CharacteristicModel[];
  lstCharIds: number[];
}

export class CountryModel {
  CountryId: number;
  Name: string;
}

export class LabsModel {
  LabId: number;
  Name: string;
}
export class CustomersSearchFields {
  CustomerId: number;
  Name: string;
  LabIds: any;
  CountryId: number;
  PageNo: number;
  PageSize: number;
}
export class PageResultDto {
  PageCount: number;
  PageNo: number;
  PageSize: number;
  TotalRecords: number;
}

export class SendMailViewModel {
  JobCardId: number;
  EmailToArray = [];
  EmailCcArray = [];
  EmailBccArray = [];
  EmailTo: string;
  EmailCc: string;
  EmailBcc: string;
  Subject: string;
  EmailBody: string;
  AttachedFileName: string;
}

export class CompanyDataModel {
  DefaultCompanyId: number;
  DefaultCompanyName: string;
  Company: CompanyModel[];
}
export class CompanyModel {
  CompanyId: number;
  CompanyName: string;
}